import type { Component } from '../schema';

/**
 * `productattribute` values from the embedding shop: the characteristic
 * names an attribute code, the shop passed the product's value for it.
 * Numeric strings become numbers so formulas can calculate with them, as
 * legacy did with `CONFIGENTO_PRODUCT.attribute`.
 *
 * Shared by the browser (ConfiguratorRoot) and the server-side price check
 * (headless/price.ts): both must turn the same shop values into the same
 * inputs, or the verified price differs from the displayed one.
 */
export function productAttributeValues(
    component: Component,
    attributes: Readonly<Record<string, string>> | undefined,
): Map<number, string | number> {
    const out = new Map<number, string | number>();
    if (!attributes) return out;
    for (const group of component.groups) {
        for (const c of group.characteristics) {
            if (c.type !== 'productattribute' || !c.productAttribute) continue;
            const raw = attributes[c.productAttribute];
            if (raw === undefined) continue;
            const n = Number(raw);
            out.set(c.id, raw.trim() !== '' && Number.isFinite(n) ? n : raw);
        }
    }
    return out;
}
